import { Col, Form, FormInstance, Radio, Row } from 'antd';
import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
} from '@/components/_common';
import { Typography } from 'antd';
import moment from 'moment';
import InsurerInfiniteSelectField from '@/components/_common/InsurerInfiniteSelectField';
import { ComparasionInsurersFormValues } from '@/core/domain/workorder/ManagementCharts/ManagementChart.types';

interface Props {
  form: FormInstance<ComparasionInsurersFormValues>;
}

function SalesInsuranceComparisonForm({ form }: Props) {
  const viewOptions = [
    {
      label: 'Valor Total',
      value: 0,
    },
    {
      label: 'Quantidade',
      value: 1,
    },
  ];

  return (
    <Form layout="vertical" form={form}>
      <Row gutter={24}>
        <Col span={24}>
          <FloatingFormItem
            name="startDate"
            label={'Data Inicial'}
            initialValue={moment().subtract(5, 'months').startOf('day')}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="endDate"
            label={'Data Final'}
            initialValue={moment().endOf('day')}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem label={'Empresas'} name="companiesIds">
            <CompaniesInfiniteSelectField mode="multiple" allowClear />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem label={'Seguradoras'} name="insurersIds">
            <InsurerInfiniteSelectField mode="multiple" allowClear />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <Typography.Title level={5}>{'Exibir'}</Typography.Title>
          <Form.Item name="managementChartType" initialValue={0}>
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              {viewOptions.map((item) => (
                <Radio value={item.value}>{item.label}</Radio>
              ))}
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default SalesInsuranceComparisonForm;
